var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-template"},[_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"page-edit"},[_c('form-template',{ref:"formTemplate",on:{"submit":_vm.submitData}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6e332a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/system/maintain/Merchants.vue
// module id = null
// module chunks = 